import ClientDashboard from './frontend/Tools/PensionCalculators/Clients/ClientDashboard';
import { ClientProvider } from './frontend/Tools/PensionCalculators/Clients/ClientContext';
import TaxFreeCashPage from './frontend/Tools/PensionCalculators/TaxFreeCash/TaxFreeCashPage';
import PensionShortfallPage from './frontend/Tools/PensionCalculators/PensionShortfall/PensionShortfallPage';
import CriticalYieldPage from './frontend/Tools/PensionCalculators/CriticalYield/CriticalYieldPage';
import AnnuityRiskPage from './frontend/Tools/PensionCalculators/AnnuityRisk/AnnuityRiskPage';
import GrowthRequiredPage from './frontend/Tools/PensionCalculators/GrowthRequired/GrowthRequiredPage';
import WeightedAveragePage from './frontend/Tools/PensionCalculators/WeightedAverage/WeightedAveragePage';
import GarPage from './frontend/Tools/PensionCalculators/Gar/GarPage';
import ReductionInYieldPage from './frontend/Tools/PensionCalculators/ReductionInYield/ReductionInYieldPage';
import "./css/App.css";
import "./css/index.css";
import ATRProfiler from "./frontend/Tools/ATRProfiler/ATRProfiler";
import { BrowserRouter as Router, Navigate, Route, Routes, useParams } from "react-router-dom";
import SignIn from "./frontend/SignIn/SignIn";
import Dashboard from "./frontend/Tools/MembersHub/Dashboard";
import FileDirectory from "./frontend/Tools/MembersHub/FileDirectory";
import { useLocation } from "react-router-dom";
import ProtectedRoute from "./backend/SignIn/ProtectedRoute";
import CashflowModeller2 from "./frontend/Tools/CashflowModeller2/CashflowModeller2";
import { CfmProvider } from "./frontend/Tools/CashflowModeller2/Context/CfmContext";
import CfmDashboard from "./frontend/Tools/CashflowModeller2/Components/Dashboard/CfmDashboard";
import AMLDashboard from "./frontend/Tools/AML/Dashboard/AMLDashboard";
import NewCheck from "./frontend/Tools/AML/Checks/NewCheck";
import CheckResult from "./frontend/Tools/AML/CheckDetails/CheckDetails";
import DebtConsolidationCalculator from "./frontend/Tools/DebtConsolidationCalculator/DebtConsolidationCalculator";
import FinancialPromotions from "./frontend/Tools/FinancialPromotions/newSubmission/NewFinancialPromotions";
import AdminMediaPage from "./frontend/Tools/FinancialPromotions/Approvals";
import FPDetails from "./frontend/Tools/FinancialPromotions/submissionDetails/FPDetails";
import { LOA } from "./frontend/Tools/LOA/LOA";
import LOADashboard from "./frontend/Tools/LOA/Dashboard/LOADashboard";
import CedingSchemePage from "./frontend/Tools/LOA/CedingScheme/CedingSchemePage";
import ProviderNetworkPage from "./frontend/Tools/ProviderNetwork/ProviderNetworkPage";
import ProviderDetailsPage from "./frontend/Tools/ProviderNetwork/ProviderDetailsPage";
import PortalSectionRouterPage from "./frontend/PortalSections/PortalSectionRouterPage";
import PortalAccessAuditPage from "./frontend/PortalSections/PortalAccessAuditPage";
import MembersHub from "./frontend/Tools/MembersHub/Dashboard";
import MyDashboard from "./frontend/Tools/Dashboard/MyDashboard";
import MyPayments from "./frontend/Tools/MyPayments/MyPayments";
import MyProfilePage from "./frontend/Tools/MyProfile/MyProfile";
import EditAdviserDetails from "./frontend/Tools/MyProfile/components/EditDetails/EditAdviserDetailsPage";
// const PING_INTERVAL = 300000; // Every 5 minutes (300,000 ms)

// const keepServerAwake = () => {
//   fetch("https://adviser-portal-members-hub.onrender.com/api/status")
//     .then(() => {
//       console.log("Pinged Render API to keep it awake");
//     })
//     .catch((err) => {
//       console.error("Ping failed:", err);
//     });
// };

function PensionClientWorkspace() {
  const { calculatorId } = useParams();
  const Page = { 'tax-free-cash': TaxFreeCashPage, 'pension-shortfall': PensionShortfallPage, 'critical-yield': CriticalYieldPage, 'annuity-risk': AnnuityRiskPage, 'growth-required': GrowthRequiredPage, 'weighted-average': WeightedAveragePage, 'gar': GarPage, 'reduction-in-yield': ReductionInYieldPage }[calculatorId];
  return Page ? <Page /> : <Navigate to="/portal/tools-calculators/pension-calculators" replace />;
}

function App() {
  // useEffect(() => {
  //   keepServerAwake(); // Ping once when the component mounts
  //   const interval = setInterval(keepServerAwake, PING_INTERVAL);
  //   return () => clearInterval(interval); // Cleanup interval on unmount
  // }, []);
  return (
    <Router>
      <Routes>
        <Route path="/portal/tools-calculators/pension-calculators" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
        <Route path="/portal/tools-calculators/pension-calculators/clients/:ownerEmail/:clientId/:calculatorId" element={<ProtectedRoute><ClientProvider><PensionClientWorkspace /></ClientProvider></ProtectedRoute>} />
        <Route path="/portal/tools-calculators/gar" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/portal/tools-calculators/reduction-in-yield" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/portal/tools-calculators/tax-free-cash" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/portal/tools-calculators/pension-shortfall" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/portal/tools-calculators/critical-yield" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/portal/tools-calculators/annuity-risk" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/portal/tools-calculators/growth-required" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/portal/tools-calculators/weighted-average" element={<Navigate to="/portal/tools-calculators/pension-calculators" replace />} />
        <Route path="/business-summary" element={<ProtectedRoute><MyPayments /></ProtectedRoute>} />
        <Route path="/my-payments" element={<Navigate to="/business-summary" replace />} />
        <Route path="/my-entries" element={<Navigate to="/business-summary" replace />} />
        <Route path="/" element={<SignIn />} />
        <Route path="/*" element={<SignIn />} />
        {/* <Route path="/" element={<ATRProfiler />} /> */}

        <Route
          path="/my-dashboard"
          element={
            <ProtectedRoute>
              {/* {console.log("[App] Rendering /my-dashboard route")} */}
              <MyDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/members-hub"
          element={
            <ProtectedRoute>
              {/* {console.log("[App] Rendering /members-hub route")} */}
              <MembersHub />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/atr-profiler"
          element={
            <ProtectedRoute>
              <ATRProfiler />
            </ProtectedRoute>
          }
        />

        <Route
          path="/cashflow-modeller"
          element={
            <ProtectedRoute>
              <CfmProvider>
                <CashflowModeller2 />
              </CfmProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cashflow-modeller-dashboard"
          element={
            <ProtectedRoute>
              <CfmProvider>
                <CfmDashboard />
              </CfmProvider>
            </ProtectedRoute>
          }
        />

        <Route
          path="/members-hub/:folderName/*"
          element={
            <ProtectedRoute>
              <FileDirectory />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/Check²"
          element={
            <ProtectedRoute>
              <NewCheck />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/check²"
          element={
            <ProtectedRoute>
              <AMLDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/new-check"
          element={
            <ProtectedRoute>
              <NewCheck />
            </ProtectedRoute>
          }
        />
        <Route
          path="/check²/result"
          element={
            <ProtectedRoute>
              <CheckResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/financial-promotions"
          element={
            <ProtectedRoute>
              <AdminMediaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/financial-promotions/new"
          element={
            <ProtectedRoute>
              <FinancialPromotions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/financial-promotions/details/:submissionId"
          element={
            <ProtectedRoute>
              <FPDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/debt-sense"
          element={
            <ProtectedRoute>
              <DebtConsolidationCalculator />
            </ProtectedRoute>
          }
        />

        <Route
          path="/provider-index"
          element={
            <ProtectedRoute>
              <ProviderNetworkPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/provider-index/:providerId"
          element={
            <ProtectedRoute>
              <ProviderDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pro-ceding/new"
          element={
            <ProtectedRoute>
              <LOA />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pro-ceding/:extractionId"
          element={<CedingSchemePage />}
        />
        <Route path="/pro-ceding/dashboard" element={<LOADashboard />} />
        <Route
          path="/portal/:sectionKey"
          element={
            <ProtectedRoute>
              <PortalSectionRouterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portal-access-audit"
          element={
            <ProtectedRoute>
              <PortalAccessAuditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-profile"
          element={
            <ProtectedRoute>
              <MyProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-profile/:adviserKey/edit"
          element={
            <ProtectedRoute>
              <EditAdviserDetails />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
